"use strict";

exports.__esModule = true;
exports.STORE_GLOBAL_LOCATION = exports.SET_GLOBAL_LOCATION = void 0;
var SET_GLOBAL_LOCATION = 'commonSetLocation/SET_GLOBAL_LOCATION';
exports.SET_GLOBAL_LOCATION = SET_GLOBAL_LOCATION;
var STORE_GLOBAL_LOCATION = 'commonSetLocation/STORE_GLOBAL_LOCATION';
exports.STORE_GLOBAL_LOCATION = STORE_GLOBAL_LOCATION;